export function updateUserRoleInUsers(users, targetUserId, windfarmId, updatedRole) {
    return users.map(user =>
        user.id === targetUserId
            ? {
                ...user,
                windfarms: user.windfarms.map(wf =>
                    wf.id === windfarmId
                        ? {
                            ...wf,
                            role: updatedRole === 'no access' ? null : updatedRole,
                            scenarios: updatedRole === 'no access'
                                ? wf.scenarios.map(scenario => ({ ...scenario, subscribed: false }))
                                : wf.scenarios
                        }
                        : wf
                )
            }
            : user
    );
}

export function updateUserRoleInWindfarms(windfarms, targetUserId, windfarmId, updatedRole) {
    return windfarms.map(wf =>
        wf.id === windfarmId
            ? {
                ...wf,
                users: wf.users.map(user =>
                    user.id === targetUserId
                        ? { ...user, role: updatedRole === 'no access' ? null : updatedRole }
                        : user
                )
            }
            : wf
    );
}
